import NumberInput from '~/modules/common/components/NumberInput';

export default NumberInput;
